


















































import Vue from 'vue'

import UnsupportedFileFormat from '@/common/components/modalUploadImage/UnsupportedFileFormat.vue'
import OverSize from '@/common/components/modalUploadImage/OverSize.vue'
import PngOverDimensions from '@/common/components/modalUploadImage/PngOverDimensions.vue'
import PdfOverDimensions from '@/common/components/modalUploadImage/PdfOverDimensions.vue'
import JpgOverDimensions from '@/common/components/modalUploadImage/JpgOverDimensions.vue'
import PsdOverDimensions from '@/common/components/modalUploadImage/PsdOverDimensions.vue'
import BadFile from '@/common/components/modalUploadImage/BadFile.vue'
import UnknownError from '@/common/components/modalUploadImage/UnknownError.vue'

import { AddImageStates } from '@/common/constants/imageUpload'
import AiOverDimensions from './AiOverDimensions.vue'

export default Vue.extend({
  components: {
    UnsupportedFileFormat,
    OverSize,
    PngOverDimensions,
    PdfOverDimensions,
    BadFile,
    UnknownError,
    JpgOverDimensions,
    PsdOverDimensions,
    AiOverDimensions
  },
  props: {
    addImageState: {
      type: String,
      required: true
    }
  },
  computed: {
    idle(): boolean {
      return this.addImageState === AddImageStates.IDLE
    },
    unsupportedFileFormat(): boolean {
      return this.addImageState === AddImageStates.UNSUPPORTED_FILE_FORMAT
    },
    overSize(): boolean {
      return (
        this.addImageState === AddImageStates.PNG_OVER_SIZE ||
        this.addImageState === AddImageStates.PDF_OVER_SIZE ||
        this.addImageState === AddImageStates.PSD_OVER_SIZE ||
        this.addImageState === AddImageStates.JPEG_OVER_SIZE ||
        this.addImageState === AddImageStates.AI_OVER_SIZE
      )
    },
    pngOverDimensions(): boolean {
      return this.addImageState === AddImageStates.PNG_OVER_DIMENSIONS
    },
    pdfOverDimensions(): boolean {
      return this.addImageState === AddImageStates.PDF_OVER_DIMENSIONS
    },
    jpgOverDimensions(): boolean {
      return this.addImageState === AddImageStates.JPEG_OVER_DIMENSIONS
    },
    psdOverDimensions(): boolean {
      return this.addImageState === AddImageStates.PSD_OVER_DIMENSIONS
    },
    aiOverDimensions(): boolean {
      return this.addImageState === AddImageStates.AI_OVER_DIMENSIONS
    },
    badFile(): boolean {
      return (
        this.addImageState === AddImageStates.UPLOAD_FAILED_BAD_FILE ||
        this.addImageState === AddImageStates.PDF_MULTIPLE_PAGES ||
        this.addImageState === AddImageStates.AI_MULTIPLE_ARTBOARDS ||
        this.addImageState === AddImageStates.AI_INCOMPATIBLE_VERSION ||
        this.addImageState === AddImageStates.PROCESSING_FAILED_BAD_FILE
      )
    },
    unknownError(): boolean {
      return this.addImageState === AddImageStates.PROCESSING_FAILED_UNKNOWN
    }
  },
  methods: {
    updateAddImageState(newState: AddImageStates) {
      this.$emit('updateAddImageState', newState)
    }
  }
})
